import { Link } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import { Header, Main } from "../commons/Template/Template";
import routes from "../../routes/routes";
import Typo, { Em } from "../commons/Typo/Typo";

// Component shown when the authenticated user has an inactive account
export default function Inactive() {
  const { t } = useTranslation(["common", "account"]);
  document.title = t("account:inactive.title");

  return (
    <Main>
      <Header>
        <Typo variant="h1">
          <Trans
            t={t}
            i18nKey="account:inactive.heading"
            components={{
              emphasis: <Em />,
            }}
          />
        </Typo>
        <Typo variant="body2">
          <Trans
            t={t}
            i18nKey="account:inactive.subheading"
            components={{
              anchor: <Link to={`mailto:${routes.EmailSupport}`} />,
            }}
          />
        </Typo>
      </Header>
    </Main>
  );
}
